import {onBeforeUnmount, onMounted} from 'vue';
import {useResumeImportStore} from '../store/useResumeImportStore';
import type {FunnelCtaHandlerForNext} from '../types/FunnelCtaHandler';

export function useDefineFunnelNextStepHandler(handler: FunnelCtaHandlerForNext) {
    const {registerHandlerForCtaNext, unregisterHandlerForCtaNext} = useResumeImportStore();

    onMounted(() => {
        registerHandlerForCtaNext(handler);
    });
    onBeforeUnmount(() => {
        unregisterHandlerForCtaNext();
    });
}
